$ = require('jquery')

module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.f-filter__btn').each(->

			$this = $(@)
			$('body').append('<div class="f-filter__btn f-filter__btn--fixed">' + $this.html() + '<div>')
			$btn = $('.f-filter__btn--fixed')

			$btn.width( $this.width() )

			offsetTop = $('.f-filter').offset().top
			offsetBottom = $this.offset().top
			windowHeight = $(window).height()

			$(window)
				.on('resize', ->
					$btn.width( $this.width() )

					offsetTop = $('.f-filter').offset().top
					offsetBottom = $this.offset().top
					windowHeight = $(window).height()
				)
				.on('scroll', ->
					if $(this).scrollTop() + windowHeight < offsetTop || $(this).scrollTop() + windowHeight > offsetBottom
						$btn.removeClass('is-active')
					else
						$btn.addClass('is-active')
				)

			return
		)

		$target.find('.footer__top').each(->

			$this = $(@)

			$(window)
				.on('scroll', ->
					if $(document).scrollTop() > 200
						$this.addClass('is-active')
					else
						$this.removeClass('is-active')
				)

			return
		)

		$(window).trigger('scroll')

		return



// WEBPACK FOOTER //
// ./src/js/components/fixed.coffee